<template>
  <div class="level-modification">
    <img class="delete-cross" @click="deleteModification" src="../../assets/images/delete-cross.png" />
    <l-map class="level-map" :ref="mapID" @ready="onMapReady" :options="mapOptions"> </l-map>
    <table>
      <tr>
        <td>
          <label :for="startID">{{ $t('scenario.start') }}:</label>
        </td>
        <td>
          <select :name="startID" v-model="start">
            <option value="">-</option>
            <option value="01-01">1 {{ $t('datetime.january') }}</option>
            <option value="01-08">8 {{ $t('datetime.january') }}</option>
            <option value="01-15">15 {{ $t('datetime.january') }}</option>
            <option value="01-22">22 {{ $t('datetime.january') }}</option>
            <option value="02-01">1 {{ $t('datetime.february') }}</option>
            <option value="02-08">8 {{ $t('datetime.february') }}</option>
            <option value="02-15">15 {{ $t('datetime.february') }}</option>
            <option value="02-22">22 {{ $t('datetime.february') }}</option>
            <option value="03-01">1 {{ $t('datetime.march') }}</option>
            <option value="03-08">8 {{ $t('datetime.march') }}</option>
            <option value="03-15">15 {{ $t('datetime.march') }}</option>
            <option value="03-22">22 {{ $t('datetime.march') }}</option>
            <option value="04-01">1 {{ $t('datetime.april') }}</option>
            <option value="04-08">8 {{ $t('datetime.april') }}</option>
            <option value="04-15">15 {{ $t('datetime.april') }}</option>
            <option value="04-22">22 {{ $t('datetime.april') }}</option>
            <option value="05-01">1 {{ $t('datetime.may_long') }}</option>
            <option value="05-08">8 {{ $t('datetime.may_long') }}</option>
            <option value="05-15">15 {{ $t('datetime.may_long') }}</option>
            <option value="05-22">22 {{ $t('datetime.may_long') }}</option>
            <option value="06-01">1 {{ $t('datetime.june') }}</option>
            <option value="06-08">8 {{ $t('datetime.june') }}</option>
            <option value="06-15">15 {{ $t('datetime.june') }}</option>
            <option value="06-22">22 {{ $t('datetime.june') }}</option>
            <option value="07-01">1 {{ $t('datetime.july') }}</option>
            <option value="07-08">8 {{ $t('datetime.july') }}</option>
            <option value="07-15">15 {{ $t('datetime.july') }}</option>
            <option value="07-22">22 {{ $t('datetime.july') }}</option>
            <option value="08-01">1 {{ $t('datetime.august') }}</option>
            <option value="08-08">8 {{ $t('datetime.august') }}</option>
            <option value="08-15">15 {{ $t('datetime.august') }}</option>
            <option value="08-22">22 {{ $t('datetime.august') }}</option>
            <option value="09-01">1 {{ $t('datetime.september') }}</option>
            <option value="09-08">8 {{ $t('datetime.september') }}</option>
            <option value="09-15">15 {{ $t('datetime.september') }}</option>
            <option value="09-22">22 {{ $t('datetime.september') }}</option>
            <option value="10-01">1 {{ $t('datetime.october') }}</option>
            <option value="10-08">8 {{ $t('datetime.october') }}</option>
            <option value="10-15">15 {{ $t('datetime.october') }}</option>
            <option value="10-22">22 {{ $t('datetime.october') }}</option>
            <option value="11-01">1 {{ $t('datetime.november') }}</option>
            <option value="11-08">8 {{ $t('datetime.november') }}</option>
            <option value="11-15">15 {{ $t('datetime.november') }}</option>
            <option value="11-22">22 {{ $t('datetime.november') }}</option>
            <option value="12-01">1 {{ $t('datetime.december') }}</option>
            <option value="12-08">8 {{ $t('datetime.december') }}</option>
            <option value="12-15">15 {{ $t('datetime.december') }}</option>
            <option value="12-22">22 {{ $t('datetime.december') }}</option>
          </select>
        </td>
        <td>
          <label :for="stopID">{{ $t('scenario.stop') }}:</label>
        </td>
        <td>
          <select :name="stopID" v-model="stop">
            <option value="">-</option>
            <option value="01-01">1 {{ $t('datetime.january') }}</option>
            <option value="01-08">8 {{ $t('datetime.january') }}</option>
            <option value="01-15">15 {{ $t('datetime.january') }}</option>
            <option value="01-22">22 {{ $t('datetime.january') }}</option>
            <option value="02-01">1 {{ $t('datetime.february') }}</option>
            <option value="02-08">8 {{ $t('datetime.february') }}</option>
            <option value="02-15">15 {{ $t('datetime.february') }}</option>
            <option value="02-22">22 {{ $t('datetime.february') }}</option>
            <option value="03-01">1 {{ $t('datetime.march') }}</option>
            <option value="03-08">8 {{ $t('datetime.march') }}</option>
            <option value="03-15">15 {{ $t('datetime.march') }}</option>
            <option value="03-22">22 {{ $t('datetime.march') }}</option>
            <option value="04-01">1 {{ $t('datetime.april') }}</option>
            <option value="04-08">8 {{ $t('datetime.april') }}</option>
            <option value="04-15">15 {{ $t('datetime.april') }}</option>
            <option value="04-22">22 {{ $t('datetime.april') }}</option>
            <option value="05-01">1 {{ $t('datetime.may_long') }}</option>
            <option value="05-08">8 {{ $t('datetime.may_long') }}</option>
            <option value="05-15">15 {{ $t('datetime.may_long') }}</option>
            <option value="05-22">22 {{ $t('datetime.may_long') }}</option>
            <option value="06-01">1 {{ $t('datetime.june') }}</option>
            <option value="06-08">8 {{ $t('datetime.june') }}</option>
            <option value="06-15">15 {{ $t('datetime.june') }}</option>
            <option value="06-22">22 {{ $t('datetime.june') }}</option>
            <option value="07-01">1 {{ $t('datetime.july') }}</option>
            <option value="07-08">8 {{ $t('datetime.july') }}</option>
            <option value="07-15">15 {{ $t('datetime.july') }}</option>
            <option value="07-22">22 {{ $t('datetime.july') }}</option>
            <option value="08-01">1 {{ $t('datetime.august') }}</option>
            <option value="08-08">8 {{ $t('datetime.august') }}</option>
            <option value="08-15">15 {{ $t('datetime.august') }}</option>
            <option value="08-22">22 {{ $t('datetime.august') }}</option>
            <option value="09-01">1 {{ $t('datetime.september') }}</option>
            <option value="09-08">8 {{ $t('datetime.september') }}</option>
            <option value="09-15">15 {{ $t('datetime.september') }}</option>
            <option value="09-22">22 {{ $t('datetime.september') }}</option>
            <option value="10-01">1 {{ $t('datetime.october') }}</option>
            <option value="10-08">8 {{ $t('datetime.october') }}</option>
            <option value="10-15">15 {{ $t('datetime.october') }}</option>
            <option value="10-22">22 {{ $t('datetime.october') }}</option>
            <option value="11-01">1 {{ $t('datetime.november') }}</option>
            <option value="11-08">8 {{ $t('datetime.november') }}</option>
            <option value="11-15">15 {{ $t('datetime.november') }}</option>
            <option value="11-22">22 {{ $t('datetime.november') }}</option>
            <option value="12-01">1 {{ $t('datetime.december') }}</option>
            <option value="12-08">8 {{ $t('datetime.december') }}</option>
            <option value="12-15">15 {{ $t('datetime.december') }}</option>
            <option value="12-22">22 {{ $t('datetime.december') }}</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>
          <label :for="operatorID">{{ $t('scenario.operation') }}:</label>
        </td>
        <td>
          <select :name="operatorID" v-model="operator">
            <option value="+">+</option>
            <option value="-">-</option>
            <option value="=">=</option>
          </select>
          <input type="number" :name="valueID" v-model.number="value" step="any">
          <span v-if="modification.operator == '='">mNAP</span><span v-else>m</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';
  import "leaflet/dist/leaflet.css";
  import "leaflet-draw/dist/leaflet.draw.css";
  import L from 'leaflet';
  import { LMap } from 'vue2-leaflet';
  import 'leaflet-draw';
  import togeojson from 'togeojson';
  import fileLayer from 'leaflet-filelayer';
  import scenarioModificationHelper from '@/helpers/scenarioModificationHelper';
  fileLayer(null, L, togeojson);  // https://github.com/makinacorpus/Leaflet.FileLayer/issues/60#issuecomment-438757995

  export default {
    name: 'levelModification',
    props: ['modification', 'areas'],
    data () {
      return {
        map: null,
        mapOptions: {
          zoomControl: false,
        }
      }
    },
    computed: {
      mapID() {
        return 'map-' + this.modification.id;
      },
      startID() {
        return 'start-' + this.modification.id;
      },
      stopID() {
        return 'stop-' + this.modification.id;
      },
      operatorID() {
        return 'operator-' + this.modification.id;
      },
      valueID() {
        return 'value-' + this.modification.id;
      },
      start: {
        get() {return this.modification.start;},
        set(value) {this.setModification('start', value);}
      },
      stop: {
        get() {return this.modification.stop;},
        set(value) {this.setModification('stop', value);}
      },
      operator: {
        get() {return this.modification.operator;},
        set(value) {this.setModification('operator', value);}
      },
      value: {
        get() {return this.modification.value;},
        set(value) {this.setModification('value', value);}
      }
    },
    methods: {
      ...mapMutations('scenarioState', ['updateModification']),
      setModification(key, value) {
        this.updateModification({
          modificationType: 'level',
          id: this.modification.id,
          key: key,
          value: value
        });
      },
      deleteModification() {
        this.$emit('delete-modification', this.modification.id);
      },
      addAreas(modificationLayer) {
        L.geoJSON(this.areas).addTo(this.map).eachLayer(function(layer) {
          var style = {
            unselectedOut: {"color": "#0078ff", "weight": 1, "opacity": 0.25, "fillOpacity": 0.1},
            unselectedOver: {"color": "#0078ff", "weight": 3, "opacity": 0.75, "fillOpacity": 0.5},
            selectedOver: {"color": "#ff7800", "weight": 3, "opacity": 0.75, "fillOpacity": 0.5},
            selectedOut: {"color": "#ff7800", "weight": 3, "opacity": 0.75, "fillOpacity": 0.1}
          };
          layer.setStyle(style.unselectedOut);
          layer.on('mouseover', function() {
            if (modificationLayer.hasLayer(this)) {
              this.setStyle(style.selectedOver);
            }
            else {
              this.setStyle(style.unselectedOver);
            }
          });
          layer.on('mouseout', function() {
            if (modificationLayer.hasLayer(this)) {
              this.setStyle(style.selectedOut);
            }
            else {
              this.setStyle(style.unselectedOut);
            }
          });
          layer.on('click', function() {
            if (modificationLayer.hasLayer(this)) {
              modificationLayer.removeLayer(this);
              this.setStyle(style.unselectedOver);
            }
            else {
              this.addTo(modificationLayer);
              this.setStyle(style.selectedOver);
            }
          });
        });
      },
      onMapReady() {
        var modificationLayer = this.modification.layer;
        this.map = this.$refs[this.mapID].mapObject;
        this.map.attributionControl.setPrefix('<a href="https://leafletjs.com" title="A JavaScript library for interactive maps"> Leaflet</a>');
        this.map.addLayer(
          L.tileLayer(
            "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", 
            {attribution: "&copy; <a target='_blank' href='http://osm.org/copyright'>OpenStreetMap</a> contributors",}
        ));
        scenarioModificationHelper.setInitialZoom(this.map);
        if (this.areas.features.length > 0) {
          this.addAreas(modificationLayer);
        }
        else {
          scenarioModificationHelper.addDrawControl(this.map, modificationLayer);
        }

        // File upload control:
        var control = L.Control.fileLayerLoad({
            fileSizeLimit: 10*1024,
            formats: ['.geojson', '.kml']
        });
        control.addTo(this.map);
        control.loader.on('data:loaded', function (event) {
          event.layer.addTo(modificationLayer);
        });
      },
    },
    components: {
      LMap
    },
  }
</script>

<style scoped>
  .level-modification {
    border: solid black 1px;
    border-top: solid #00008c 30px;
    border-radius: 5px;
    margin-bottom: 10px;
  }
  .level-modification label {
    margin: 3px 10px;
  }
  .level-modification input {
    height: 30px;
    width: 100px;
    margin: 3px;
  }
  .delete-cross {
    float: right;
    width: 18px;
    height: 24px;
    margin-top: -27px;
    margin-right: 3px;
  }
  .level-map {
    height: 500px;
  }
</style>
